import React, { Component } from 'react';
import ErrorFallback from '../ErrorFallBackComponent';

export default (
  loader,
  { Loading, preload = false, delay = 0, reloadOnFailed = true, timeout = 10000, component } = {}
) => {
  let loadedComponent = null;

  const load = () =>
    new Promise((resolve, reject) => {
      if (loadedComponent) {
        return resolve(loadedComponent);
      } else {
        let time = setTimeout(() => {
          // Loading Timeout
          if (!loadedComponent) return reject(new Error('Error Loading Component!'));
        }, timeout);

        loader()
          .then((result) => {
            loadedComponent = result.default;
            clearTimeout(time);
            return resolve(result.default);
          })
          .catch((err) => {
            reject(err.message);
          });
      }
    });

  class AsyncLoader extends Component {
    state = {
      Component: null,
      error: false,
      reload: false,
      caughtError: false,
      hasError: false,
      aError: '',
      errorInfo: '',
    };

    componentWillMount() {
      load()
        .then((Component) => this.setState({ Component }))
        .catch((err) => {
          this.setState({ error: true, reload: reloadOnFailed });
        });
    }

    static getDerivedStateFromError(error) {
      return { hasError: true, aError: error };
    }

    componentDidCatch(error, errorInfo) {
      this.setState({ hasError: true, aError: error, errorInfo });
      // window.location.reload();
    }

    componentDidMount() {
      
    }

    render() {
      const { Component, reload, hasError, aError, errorInfo } = this.state;
      if (hasError) {
        return <ErrorFallback error={aError} errorInfo={errorInfo} />;
      } else {
        if (reload) {
          window.location.reload();
          return null;
        }

        if (this.state.Component) {
          return <Component {...this.props} />;
        }

        return Loading ? <Loading /> : null;
      }
    }
  }

  if (preload) {
    setTimeout(load, delay);
  }

  return AsyncLoader;
};



// WEBPACK FOOTER //
// ./src/HOC/loadComponent.js